
/** Convert a datetime-local string to a full ISO string (UTC) for timestamptz columns */
const inputToISO = (value) => {
  const dt = new Date(value);
  return dt.toISOString();
};

/** Convert a Date to the value expected by <input type="datetime-local"> (local time, no Z) */
const toInputDateTime = (d) => {
  const pad = (n) => String(n).padStart(2, '0');
  const dt = new Date(d instanceof Date ? d : new Date(d));
  const yyyy = dt.getFullYear();
  const mm = pad(dt.getMonth() + 1);
  const dd = pad(dt.getDate());
  const hh = pad(dt.getHours());
  const mi = pad(dt.getMinutes());
  return `${yyyy}-${mm}-${dd}T${hh}:${mi}`;
};

const twoDigits = (n) => String(n).padStart(2, '0');
const toHHMM = (d) => `${twoDigits(d.getHours())}:${twoDigits(d.getMinutes())}`;
const toHHMMSS = (t) => (/^\d{2}:\d{2}$/.test(t) ? `${t}:00` : t);
const DAY_TO_JS = { sun: 0, mon: 1, tue: 2, wed: 3, thu: 4, fri: 5, sat: 6 };
const DAY_KEYS = ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'];

function getLocalHHMMSS(date) {
  const h = String(date.getHours()).padStart(2, '0');
  const m = String(date.getMinutes()).padStart(2, '0');
  const s = String(date.getSeconds()).padStart(2, '0');
  return `${h}:${m}:${s}`;
}

/** Get month name and year from a month index (0-11) */
const getMonthYear = (date) => {
  return new Date(date + 1).toLocaleDateString('es-ES', { month: 'long' }).replace(/^\w/, (c) => c.toUpperCase()) + ' ' + new Date(date).getFullYear();
};

const DAY_LABELS_ES = {
  mon: 'Lunes',
  tue: 'Martes',
  wed: 'Miércoles',
  thu: 'Jueves',
  fri: 'Viernes',
};

const addOneHour = (hhmm) => {
  // hhmm => "HH:MM"
  const [h, m] = hhmm.split(':').map(Number);
  const d = new Date(1970, 0, 1, h, m);
  d.setHours(d.getHours() + 1);
  const two = (n) => String(n).padStart(2, '0');
  return `${two(d.getHours())}:${two(d.getMinutes())}`;
};

export default {
  inputToISO,
  toInputDateTime,
  getMonthYear,
  DAY_LABELS_ES,
  addOneHour,
  twoDigits,
  toHHMM,
  toHHMMSS,
  DAY_TO_JS,
  DAY_KEYS,
  getLocalHHMMSS
};